import { eclipseServerData } from '@wix/package-picker-shared-eclipse';

export const useJapanesePremiumExperience = () => {
  const { locale, geo } = eclipseServerData.get();
  return locale === 'ja' && geo === 'JP';
};
